// src/hooks/useSpeechToText.js
import { useEffect, useRef, useState } from "react";

export default function useSpeechToText({
  lang = "fr-FR",
  continuous = true,
  interimResults = true,
} = {}) {
  const [supported, setSupported] = useState(true);
  const [listening, setListening] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [interim, setInterim] = useState("");
  const [error, setError] = useState(null);

  const recogRef = useRef(null);

  useEffect(() => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      setSupported(false);
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = lang;
    recognition.continuous = continuous;
    recognition.interimResults = interimResults;

    recognition.onstart = () => {
      setListening(true);
      setError(null);
    };

    recognition.onend = () => {
      setListening(false);
      setInterim("");
    };

    recognition.onerror = (e) => {
      setError(e?.error || "speech_error");
      setListening(false);
    };

    recognition.onresult = (event) => {
      let finalText = "";
      let interimText = "";

      for (let i = event.resultIndex; i < event.results.length; i++) {
        const text = event.results[i][0].transcript;
        if (event.results[i].isFinal) finalText += text + " ";
        else interimText += text + " ";
      }

      if (finalText) {
        setTranscript((prev) => (prev + " " + finalText).trim());
      }
      setInterim(interimText.trim());
    };

    recogRef.current = recognition;
  }, [lang, continuous, interimResults]);

  const start = () => {
    setError(null);
    if (!recogRef.current) return;
    try {
      recogRef.current.start();
    } catch {
      // ignore "already started"
    }
  };

  const stop = () => {
    if (!recogRef.current) return;
    try {
      recogRef.current.stop();
    } catch {}
  };

  const reset = () => {
    setTranscript("");
    setInterim("");
  };

  return {
    supported,
    listening,
    transcript,
    interim,
    error,
    start,
    stop,
    reset,
  };
}
